export default __webpack_public_path__ + "locales/fr/People.json?hash=780bbe427e82e0b296e99ddff257f7ff";